import React from 'react';
import { Typography, theme } from 'antd';
import { ReadOutlined } from '@ant-design/icons';

function DocsLink({ href, children }: React.PropsWithChildren<{ href: string }>) {
  const { token } = theme.useToken();
  return (
    <Typography.Link
      href={href}
      target="_blank"
      rel="noreferrer"
      style={{ paddingLeft: token.paddingXS, paddingRight: token.paddingXS, color: '#1D39C4' }}
    >
      <ReadOutlined style={{ marginRight: token.marginXS }} />
      {children}
    </Typography.Link>
  );
}

export default DocsLink;
